<section class="about">
  <div class="about__image">
    <img src="/About.jpg" alt="About MARI" />
  </div>
  <div class="row pad about__content">
    <div class="about__inner">
      <h1 class="about__title">About</h1>
      <p class="about__text">
        MARI is a new global force in live experiences, uniting world-class events across sport, art, theatre, and lifestyle. Co-founded by Ariel Emanuel and Mark Shapiro, MARI draws on decades of leadership redefining culture and entertainment to champion the moments that bring people together.
        <br /><br />
        From the Madrid and Miami Opens to Frieze’s international art fairs, London’s Winter Wonderland, Barrett-Jackson’s legendary auctions and TodayTix’s pioneering theatre platform, MARI’s portfolio celebrates the power of live events to inspire, connect and unite. Through deep investment in culture, content and community, MARI creates unforgettable experiences that move people – and the world.
      </p>
    </div>
  </div>
</section>

<app-contact-section></app-contact-section>
